// import { concat } from 'lodash';
import RouterSysAdminInstances from './router-sys-admin-instances';

// export default concat(
//   RouterPersons,
// );

export default RouterSysAdminInstances;



// WEBPACK FOOTER //
// ./src/router/system-administration/index.js